import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Field, Form } from "react-final-form";
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import apis from '../../api';
import { GetTokenCreateUser } from '../../helpers/getTokenCreateUser';
import { FormGroup, H2, Image, Label } from './Register.styles';
import Base64Downloader from 'common-base64-downloader-react';
import "./Register.css";
import TermsModal from '../TermsModal/TermsModal';
import ReCAPTCHA from "react-google-recaptcha";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Register
Description : Primera parte del formulario de registro de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el formulario de registro desde cero.
03/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

export default function Register(props) {

    /*Propiedades del componente*/
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confPassword, setConfPassword] = useState("");
    const [mostrarSpiner, setMostrarSpiner] = useState("");
    const toast = useRef(null);
    const [displayBasic2, setDisplayBasic2] = useState(false);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [textLegalTerms, setTextLegalTerms] = useState([]);
    const [file, setFile] = useState("");
    const [loading2, setLoading2] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenTerms, setIsOpenTerms] = useState(false);
    const [loading, setLoading] = useState(false);
    const [captcha, setCaptcha] = useState(false);
    const [type, setType] = useState("");

    const recaptchaRef = React.createRef()

    useEffect(() => {
        /*Se valida que no haya otro token para el proceso de registro*/
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        localStorage.removeItem('regToken')
        return () => {
            source.cancel();
        };
    })

    useEffect(() => {
        /*Se encarga de mostar el spinner de la vista si no se ha clickeado el botón*/
        setMostrarSpiner(false);
    }, []);

    // useEffect(async () => {
    //     /*Se encarga de mostar el spinner de la vista si no se ha clickeado el botón*/
    //     await apis.postLegalTerms({}).then(res => {
    //         let doc = "data:application/pdf;base64," + res.data.PDF.DATA
    //         setFile(doc)
    //         var textLegal = res.data.TXT.split("|");
    //         setTextLegalTerms(textLegal);
    //         console.log(textLegal)
    //     }).catch(err => {
    //         console.log(err)
    //     })
    // }, []);

    const showModalVideo = () => {
        setIsOpen(true);
    };

    const hideModalVideo = () => {
        setIsOpen(false);
    };

    const showModalTerms = () => {
        setIsOpenTerms(true);
    }

    const hideModalTerms = () => {
        setIsOpenTerms(false);
    }

    const videoHeader = (
        <div>
            <h3>Instructivo registro</h3>
        </div>
    )

    function desencrypt(cadena) {
        /*Funcion que desencripta basada en un algoritmo hecho por Carlos Mejia*/
        const arr = cadena.split("");
        let desencrypted = "";
        arr.forEach(element => {
            let ascii = element.charCodeAt(0);
            let esPar = ((ascii % 2) + 2) % 2
            if (esPar == 0) {
                ascii += parseInt(process.env.REACT_APP_EVEN);
            }
            else {
                ascii += parseInt(process.env.REACT_APP_ODD);
            }
            let charReal = String.fromCharCode(ascii);
            desencrypted += charReal;
        });
        return desencrypted;
    }

    const dialogFuncMap = {
        'displayBasic2': setDisplayBasic2
    }

    const onClick = (name) => {
        dialogFuncMap[`${name}`](true);


    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    const renderFooter = (name) => {
        return (
            <div className='pt-2'>
                <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={file} downloadName="Términos.pdf" onDownloadSuccess={() => { setLoading2(false) }}>
                    <Button label="Descargar pdf" icon="pi pi-file-pdf" onClick={() => setLoading2(true)} className="p-button-outlined p-button-sm absolute bottom-0 left-0 mb-3 ml-2" />
                </Base64Downloader>
                <div className='-mb-2'>
                    <Button label="No Acepto" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
                    <Button label="Acepto" loading={loadingCreate} icon="pi pi-check" onClick={(() => { postUser() })} className="p-button-text" />
                </div>
            </div>
        );
    }

    function validateForm() {
        /*Valida el contenido de los campos de entrada del componente*/
        const regExpStrong = /^(?=.*[!@#$&()*\\-`.+,/\"])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/
        const regExpMed = /^(((?=.* [!@#$& () *\\-`.+,/\"])(?=.*[A-Z]))|((?=.*[!@#$&()\\-`.+, /\"])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})./
        const regExpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
        return email.length > 0 && password.length > 0 && (regExpStrong.test(password) || regExpMed.test(password))
            && regExpEmail.test(email) && password == confPassword;
    }


    function validateFormRegistro() {
        return validateForm();
    }

    function onSubmit(event) {
        // event.preventDefault();
    }

    const showConfirm = (name, id) => {
        /*Función encargada de mostar al usuario un mensaje de confirmación de la realización de un proceso */
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Usuario {name}({id}) creado existosamente</p>
                    </div>
                    <div style={{ justifyContent: 'center' }} className="grid p-fluid">
                        <Link style={{ textDecoration: 'none' }} to="/Login">
                            <Button type="button" label="Ir a iniciar sesión" className="p-button-success" />
                        </Link>
                    </div>
                </div>
            )
        });
    }

    async function postUser() {
        setLoading(true);
        setLoadingCreate(true);
        /*Función encargada de guardar el usuario en la base de datos */
        const user_name = email
        const pass = confPassword


        let pass2 = desencrypt(process.env.REACT_APP_CREATE_KEY);

        try {

            let tiempo = []
            await apis.getTimeNow().then(res => {
                tiempo = res.data.DATE.split(" ")
            })
            let hora = tiempo[1].split(":")
            hora = hora[0] + hora[1]
            let fecha = tiempo[0].split("-")
            fecha = fecha[2] + fecha[0] + fecha[1]
            let userToken = GetTokenCreateUser(process.env.REACT_APP_CREATE_USER, pass2, hora, fecha)

            const usuario = {
                userName: user_name,
                password: pass,
                status: 'A',
                roleId: 7,
                legal_terms: 'S',
                token: userToken
            };

            await apis.saveUserToken(usuario).then(res => {
                setLoadingCreate(false);
                setDisplayBasic2(false);
                setLoading(false);
                showConfirm(res.data.userName, res.data.userId)
                hideModalTerms();
            })
        }
        catch (err) {
            setLoadingCreate(false);
            setDisplayBasic2(false);
            setLoading(false);
            let msg = err.response !== undefined ? err.response.data.message : "Error al crear el usuario"
            console.log(err);
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: msg, sticky: true });

        }

    }

    const passwordHeader = <h6>Seleccione su contraseña</h6>;
    const passwordFooter = (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
            <Divider />
            <p className="mt-2">Sugerencias</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Al menos una mayúscula</li>
                <li>Al menos un número</li>
                <li>Al menos uno de estos carácteres (* . ! $ _)</li>
                <li>Mínimo 8 caracteres</li>
            </ul>
        </div>
    );

    const passwordConfHeader = <h6>Seleccione su contraseña</h6>;
    const passwordConfFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Sugerencias</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Ambas contraseñas deben coincidir</li>
            </ul>
        </React.Fragment>
    );

    const onChange = async () => {
        const recaptchaValue = recaptchaRef.current.getValue();
        let payload = {
            response: recaptchaValue
        }
        try {
            await apis.postCaptcha(payload).then(res => {
                const resp = res.data.success
                if (resp) {
                    setCaptcha(resp)
                }
                else {
                    setCaptcha(resp)
                    recaptchaRef.current.reset();
                }
            })
        }
        catch (err) {
            console.log(process.env.REACT_APP_ENV)
            if (process.env.REACT_APP_ENV === 'local') {
                setCaptcha(true)
            }
            else {
                setCaptcha(false)
                recaptchaRef.current.reset();
            }
        }
    }

    /*Renderizado del componente*/
    return (<>

        <Dialog header={videoHeader} visible={isOpen} position="top" draggable={false} resizable={false} modal onHide={hideModalVideo}>
            <iframe
                width="853"
                height="480"
                src={localStorage.getItem('REGISTER_VIDEO')}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
            />
        </Dialog>

        <Form
            className="form"
            onSubmit={onSubmit}
            validate={() => {
                const errors = {};
                if (password !== confPassword && confPassword !== '') {
                    errors.confPassword = " (No coincide)";
                }
                if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email) && email !== '') {
                    errors.email = ' (Correo inválido. Ej. ejemplo@email.com)';
                }
                return errors;
            }}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form style={{ marginRight: "4rem" }} className='form' onSubmit={handleSubmit}>
                    {/* <Dialog header="Terminos y condiciones" visible={displayBasic2} style={{ width: '50vw' }} footer={renderFooter('displayBasic2')} onHide={() => onHide('displayBasic2')}>
                        {
                            textLegalTerms.map((item, index) => {
                                return <div key={index}> <p >{item}</p> <br /></div>

                            })
                        }
                    </Dialog> */}
                    <TermsModal
                        accept={postUser}
                        cancel={hideModalTerms}
                        isOpenTerms={isOpenTerms}
                        setIsOpenTerms={setIsOpenTerms}
                        loading={loading}
                        setLoading={setLoading}
                    />
                    <Toast ref={toast} style={{ backgroundColor: 'white' }} />
                    <H2 style={{ marginTop: "-2rem", marginBottom: "4rem" }}>
                        <Image
                            src={process.env.REACT_APP_LOGO_LOGIN}
                            alt="MiRemuner"
                            style={{ width: "20rem", height: "20rem" }}
                        />
                    </H2>
                    <div style={{ marginTop: "-8rem", marginBottom: '1rem' }} className="mb-3 font-bold text-4xl">
                        <span className="text-900">Registro</span>
                    </div>
                    {type === '' || type === 'company' && <Button block label="Volver a seleccionar servicio"
                        size='small' type="submit" className='mb-1' te
                        onClick={() => {
                            setType('')
                        }}>
                    </Button>}
                    {type === '' || type === 'self' ?
                        <div className='flex flex-column gap-2 justify-content-center align-items-center'>
                            <Label style={{ marginTop: "10px" }} className='font-bold' htmlFor="label">
                                Por favor indícanos qué servicio quieres usar:
                            </Label>
                            <Button block label="MiRemuner como empresa" style={{ width: '16rem' }} type="submit"
                                onClick={() => {
                                    setType('company')
                                }}
                                disabled={type === 'self' ? true : false}
                            >
                            </Button>
                            <Button block label="MiRemuner como empleado (autogestión)" style={{ width: '16rem' }} type="submit"
                                onClick={() => {
                                    setType('self')
                                    toast.current.show({
                                        severity: 'info',
                                        summary: 'Aviso',
                                        detail: 'Para el proceso de autogestión te enviarmos al link correspondiente. Aquí podrás autohabilitarte e ingresar.',
                                        life: 5000
                                    });
                                    setTimeout(() => {
                                        window.location.href = "https://selfservice.remuner.com.co";
                                    }, 5000);
                                }}
                                loading={type === 'self' ? true : false}
                            >
                            </Button>
                        </div>
                        :
                        <>
                            <Field name="email">
                                {({ input, meta }) => (
                                    <FormGroup>
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon">
                                                <i className="pi pi-user"></i>
                                            </span>
                                            <span className="p-float-label">
                                                <InputText {...input} id="inputgroup" type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                <label htmlFor="inputgroup">Correo {!!(meta.error && meta.touched) && <small className="p-error">{meta.error}</small>}</label>
                                            </span>
                                        </div>
                                    </FormGroup>)}
                            </Field>
                            <FormGroup>
                                <div className="p-inputgroup">
                                    <span className="p-inputgroup-addon">
                                        <i className="pi pi-lock"></i>
                                    </span>
                                    <span className="p-float-label">
                                        <Password id="password" name="password" inputStyle={{ width: 'auto' }} value={password} onChange={(e) => setPassword(e.target.value)}
                                            toggleMask header={passwordHeader} footer={passwordFooter}
                                            mediumRegex={"^(((?=.*[!*.$_])(?=.*[A-Z]))|((?=.*[!*.$_])(?=.*[0-9]))|((?=.*[!*.$_])(?=.*[A-Z])(?=.*[0-9])))(?=.{6,})."}
                                            strongRegex={"^(?=.*[!*.$_])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"}
                                            weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte" promptLabel="Digite su contraseña" />
                                        <label htmlFor="inputgroup">Contraseña</label>
                                    </span>
                                </div>
                            </FormGroup>
                            <Field name="confPassword">
                                {({ input, meta }) => (
                                    <FormGroup>
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon">
                                                <i className="pi pi-lock"></i>
                                            </span>
                                            <span className="p-float-label">
                                                <Password {...input} id="password" inputStyle={{ width: 'auto' }} name="password" value={confPassword} onChange={(e) => setConfPassword(e.target.value)}
                                                    promptLabel="Digite su contraseña" toggleMask feedback={false} />
                                                <label htmlFor="inputgroup">Confirmar contraseña {!!(meta.error && meta.touched) && <small className="p-error">{meta.error}</small>}</label>
                                            </span>
                                        </div>
                                    </FormGroup>)}
                            </Field>
                            {captcha === false && email && password && confPassword &&
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    // className='captcha'
                                    style={{ marginLeft: '3rem' }}
                                    sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                                    onChange={onChange}
                                />}
                            {captcha === true && <Button block label="Crear cuenta" type="submit" disabled={!validateFormRegistro()}
                                onClick={() => {
                                    // onClick('displayBasic2')
                                    showModalTerms()
                                }
                                }>
                            </Button>}
                        </>}
                    <Label style={{ marginTop: "10px" }} htmlFor="label">
                        ¿Necesitas ayuda con el registro?
                        {' '}
                        <a style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} mouse onClick={showModalVideo}>
                            Da click aquí
                        </a>
                        {' '}
                        <i className='pi pi-youtube' style={{ color: 'red' }} />
                    </Label>
                    <Label style={{ marginTop: "5px" }} htmlFor="label">
                        ¿Ya tienes una cuenta?
                        {' '}
                        <Link to="/Login" style={{ color: 'blue', textDecoration: 'underline' }}>Ingresa</Link>
                    </Label>
                </form>
            )}
        />
    </>
    );
}